import transport from "core/model/api/transport";

export default {
  registerDeviceToken({
    accountId,
    deviceId,
    deviceToken,
  }: {
    accountId: number;
    deviceId: string;
    deviceToken: string;
  }): Promise<any> {
    return transport.put({
      body: {
        device_id: deviceId,
        device_token: deviceToken,
      },
      route: `/accounts/${accountId}/push/register`,
    });
  },
  unregisterDeviceToken({
    accountId,
    deviceId,
    deviceToken,
  }: {
    accountId: number;
    deviceId: string;
    deviceToken: string;
  }): Promise<any> {
    return transport.put({
      body: {
        device_id: deviceId,
        device_token: deviceToken,
      },
      route: `/accounts/${accountId}/push/unregister`,
    });
  },
};
